import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import MapboxDraw from '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.js';
import * as turf from '@turf/turf';
import moment from "moment";
// import L from 'leaflet';
export default {
  init() {
    const ajaxurl = window.ajaxurl;

    mapboxgl.accessToken = 'pk.eyJ1IjoidmRvcnJlZ28iLCJhIjoiY2p0cjRoc25zMGtkeDRkbGx3d2ZoNXdtZSJ9.ZAI100zuH4u8mxZs7TwXmw';
    var map = new mapboxgl.Map({
      container: 'delivery',
      style: 'mapbox://styles/mapbox/streets-v11',
      minZoom: 12,
      maxZoom: 17,
      center: [2.1559586, 41.4042873],
    });

    var geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      bbox: [2.094939, 41.354327, 2.239135, 41.456301],
    });

    map.addControl(geocoder);
    var location;
    var coordinates;
    var newCoords = [];
    var deliveryPolygon;
    var dZones;

    var deliveryBtn = document.querySelector('.map__wrapper .js--confirm');
    var alert = document.querySelector('.map__wrapper .message--alert');

    var address = document.querySelector('.map__wrapper .map_address');
    var addressNumber = document.querySelector('.map__wrapper .map_number');
    
    var mapboxInput;

    address.addEventListener('change', () => {

    })
    
    var draw = new MapboxDraw({
      displayControlsDefault: false,
      controls: {
        polygon: false,
        trash: false,
      },
    });

    Number.prototype.between = function (a, b, inclusive) {
      var min = Math.min.apply(Math, [a, b]),
        max = Math.max.apply(Math, [a, b]);
      return inclusive ? this >= min && this <= max : this > min && this < max;
    };

    map.addControl(draw);

    geocoder.on('result', function (response) {
      location = response.result;

      localStorage.setItem('user_location', JSON.stringify(location));

      if (map.getSource('geojson')) {
        map.removeLayer('measure-points');
        map.removeLayer('measure-lines');
        map.removeSource('geojson');
      }

      map.scrollZoom.enable();

      var geojson = {
        'type': 'FeatureCollection',
        'features': [],
      };

      // Used to draw a line between points
      var linestring = {
        'type': 'Feature',
        'geometry': {
          'type': 'LineString',
          'coordinates': [],
        },
      };

      map.addSource('geojson', {
        'type': 'geojson',
        'data': geojson,
      });

      // Add styles to the map
      map.addLayer({
        id: 'measure-points',
        type: 'circle',
        source: 'geojson',
        paint: {
          'circle-radius': 0,
          'circle-color': '#000',
        },
        filter: ['in', '$type', 'Point'],
      });
      map.addLayer({
        id: 'measure-lines',
        type: 'line',
        source: 'geojson',
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
        },
        paint: {
          'line-color': '#000',
          'line-width': 0,
        },
        filter: ['in', '$type', 'LineString'],
      });

      var local = {
        'type': 'Feature',
        'geometry': {
          'type': 'Point',
          'coordinates': [2.1558329, 41.4040812],
        },
        'properties': {
          'id': String(new Date().getTime()),
        },
      }

      geojson.features.push(local);

      map.on('zoomend', function () {
        setTimeout(() => {
          map.scrollZoom.disable();

          var mapWidth = document.querySelector('#delivery').offsetWidth / 2;
          var mapHeight = document.querySelector('#delivery').offsetHeight / 2;

          var features = map.queryRenderedFeatures([mapWidth, mapHeight],{layers: ['measure-points']});
          deliveryBtn.classList.add('disabled');

          geojson.features.length = 1;

          if (geojson.features.length > 1) geojson.features.pop();

          if (features.length) {
            var id = features[0].properties.id;
            geojson.features = geojson.features.filter(function (point) {
              return point.properties.id !== id;
            });
          } else {
            var point = {
              'type': 'Feature',
              'geometry': {
                'type': 'Point',
                'coordinates': [location.center[0], location.center[1]],
              },
              'properties': {
                'id': String(new Date().getTime()),
              },
            };

            geojson.features.push(point);
          }

          if (geojson.features.length > 1) {
            linestring.geometry.coordinates = geojson.features.map(function (
              point
            ) {
              return point.geometry.coordinates;
            });

            geojson.features.push(linestring);

            // Populate the distanceContainer with total distance
            var lengthToAsia = turf.length(linestring);
            

            if (!turf.inside(point, deliveryPolygon)) {
              alert.innerHTML = 'Esta dirección no esta dentro de nuestra zona de reparto, selecciona otra dirección o escoge otro método de reparto para tu pedido';
              alert.classList.remove('hidden');
            } else {
              if (!alert.classList.contains('hidden')) {
                alert.classList.add('hidden');
              }

              if (deliveryBtn.classList.contains('disabled')) {
                deliveryBtn.classList.remove('disabled');
              }

              for (let index = 0; index < dZones.length; index++) {
                const zone = dZones[index];
                
                if(lengthToAsia.between(zone['init'], zone['end'], false)) {
                  localStorage.setItem('user_zone', JSON.stringify(zone));
                  var price = zone.price_range_1.replace(',', '.');
                  window.setCookie("delivery_fee", price, 1 / 24);

                  // var xhr = new XMLHttpRequest();
                  // var formData = new FormData();

                  // formData.append("action", "apply_shipping");
                  // formData.append("delivery_fee", zone.price_range_1);
                  // xhr.open("POST", ajaxurl);
                  // xhr.send(formData);

                  // xhr.onloadend = () => {
                  //   if (xhr.status == 200) {
                  //     var response = xhr.response;
                  //     console.log(response);
                  //   } else {
                  //     console.log(xhr.response);
                  //   }
                  // }
                }
              }
            }
          }

          map.getSource('geojson').setData(geojson);
          
        }, 600);
      });
    });

    map.on('load', () => {
      mapboxInput = document.querySelector('.mapboxgl-ctrl-geocoder--input');

      addressNumber.addEventListener('change', () => {
        mapboxInput.value = address.value + ', ' + addressNumber.value;
        localStorage.setItem('addressNumber', addressNumber.value);
        geocoder.query(mapboxInput.value);
      })
    })

    function selectLocation() {
      var selectors = document.querySelectorAll('.location__selector li');
      var mapWrapper = document.querySelector('.map__wrapper');

      if(window.getCookie("user_type") == '') {
        localStorage.clear();
      }

      selectors.forEach(selector => {
        selector.addEventListener('click', (e) => {
          if(selector.getAttribute('data-location') !== 'delivery') {
            var location = selector.getAttribute('data-location');
    
            if(!selector.classList.contains('disabled')) {
              localStorage.setItem('user_delivery', location);
              document.querySelector('.location__wrapper').classList.remove('opened');
            } else {
              e.preventDefault();
            }
    
    
            window.setCookie("user_type", location, 1 / 24);
            document.querySelector('body').classList.remove('fixed');
          } else {

            selectors.forEach(s => {
              s.classList.add('hidden');
            })
            document.querySelector('.map__wrapper').classList.remove('hidden');

            map.resize();
          }
        })
      });

      var trigger = mapWrapper.querySelector('.js--confirm');
      var back = mapWrapper.querySelector('.js--back');

      trigger.addEventListener('click', (e) => {
        var element = e.target;
        var location = 'delivery';
        if (element.classList.contains('disabled')) {
          e.preventDefault();
        } else {
          if (localStorage.getItem('user_location') === null) {
            alert.innerHTML = 'Escoge una dirección de envió antes de seguir con tu pedido o escoge otra opción para tu pedido';
            alert.classList.remove('hidden');

          } else {
            if (!alert.classList.contains('hidden')) {
              alert.classList.add('hidden');
            }
            localStorage.setItem('user_delivery', location);
            document.querySelector('.location__wrapper').classList.remove('opened');

            window.setCookie("user_type", location, 1 / 24);
            document.querySelector('body').classList.remove('fixed');
          }
        }
      })

      back.addEventListener('click', () => {
        document.querySelector('.map__wrapper').classList.add('hidden');
        document.querySelector('.location__wrapper .popup__title').classList.add('hidden');

        selectors.forEach(s => {
          if(!s.classList.contains('disabled')) {
            s.classList.remove('hidden');
          }
        })
      })
      
    }

    window.addEventListener("load", () => {
      var formData = new FormData();
      var xhr = new XMLHttpRequest();
      var session = window.getCookie('user_type');
      formData.append("action", "get_zones");
      xhr.open("POST", ajaxurl);
      xhr.send(formData);

      if (session == '') {
        var locationSelector = document.querySelector('.location__wrapper');
        var popups = document.querySelectorAll('.popup');
        window.deleteAllCookies();
        locationSelector.classList.add('opened');

        popups.forEach(popup => {
          popup.classList.remove('opened');
        });
        document.querySelector('body').classList.add('fixed');
      }

      selectLocation();

      xhr.onloadend = () => {
        // var dZones;

        if (xhr.status == 200) {
          var response = xhr.response;
          var db = JSON.parse(unescape(response.slice(0, -1)));

          db.forEach(res => {

            if (res["value"] == "delivery_zones") {
              coordinates = res["text"].replace(/,2/g, ';2').split(';');
            }

            if (res["value"] == "pricing_zones") {
              // dZones = '"' + res["text"] + '"';
              var _zones = JSON.parse(unescape('"' + res["text"] + '"'));

              dZones = JSON.parse(_zones);
            }
          });

          if (coordinates) {
            coordinates.forEach(coord => {
              var lat = coord.split(',')[0] * 1;
              var lng = coord.split(',')[1] * 1;

              newCoords.push([lat, lng]);
            });
          }

          map.addSource('delivery_zone', {
            'type': 'geojson',
            'data': {
              'type': 'Feature',
              'geometry': {
                'type': 'Polygon',
                'coordinates': [newCoords],
              },
            },
          });
          map.addLayer({
            'id': 'delivery_zone',
            'type': 'fill',
            'source': 'delivery_zone',
            'layout': {},
            'paint': {
              'fill-color': '#088',
              'fill-opacity': 0.3,
            },
          });

          deliveryPolygon = {
            "type": "Feature",
            "properties": {},
            "geometry": {
              "type": "Polygon",
              'coordinates': [newCoords],
            },
          };

        } else {
          console.error('Error al recuperar los datos de la Base de datos');
          deliveryBtn.classList.add('disable');
        }
      }

      var today = window.schedule[moment().format('dddd')];
      var localSelector = document.querySelector('[data-location="local"]');

      if (Object.keys(today).length > 2) {

        var openMorning = today[0].split(':');
        var closeMorning = today[1].split(':');
        var openAfternoon = today[2].split(':');
        var closeAfternoon = today[3].split(':');

        if (moment().isBetween(moment().hour(openMorning[0]).minute(openMorning[1]).second(openMorning[2]), moment().hour(closeMorning[0]).minute(closeMorning[1]).second(closeMorning[2]))) {
          localSelector.classList.remove('hidden');
          localSelector.classList.remove('disabled');
        } else if (moment().isBetween(moment().hour(openAfternoon[0]).minute(openAfternoon[1]).second(openAfternoon[2]), moment().hour(closeAfternoon[0]).minute(closeAfternoon[1]).second(closeAfternoon[2]))) {
          localSelector.classList.remove('hidden');
          localSelector.classList.remove('disabled');
        }

      } else {
        var _openMorning = today[0].split(':');
        var _closeMorning = today[1].split(':');

        if (moment().isBetween(moment().hour(_openMorning[0]).minute(_openMorning[1]).second(_openMorning[2]), moment().hour(_closeMorning[0]).minute(_closeMorning[1]).second(_closeMorning[2]))) {
          localSelector.classList.remove('hidden');
          localSelector.classList.remove('disabled');

        }
      }
      
    })
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js